import React from "react";
import { Grid } from "material-ui";
import DocumentMeta from 'react-document-meta';

// @material-ui/icons
import PlayArrow from "@material-ui/icons/PlayArrow";
import ImportExport from "@material-ui/icons/ImportExport";
import People from "@material-ui/icons/People";
import Share from "@material-ui/icons/Share";

import { ProfileCard, ChartCard, RegularCard, Button, ItemGrid, DappIcon, Muted } from "components";
import EthAlt from 'react-cryptocoins/dist/icons/ETH-alt';

import ReactGA from 'react-ga';

import StarRatingComponent from 'react-star-rating-component';

var Reflux = require('reflux');
var createReactClass = require('create-react-class');
var DappsStore = require('../../stores/DappsStore');


const style = {
    centerText: {
        textAlign: "center",
    },
    rate: {
        fontSize: "42px",
        fontWeight: "bold",
        color: "#ff9800",
        marginBottom: "2px",
        marginTop: "8px",
    },
    note: {
        marginTop: "10px",
        marginBottom: "10px"
    },
    shareButton: {
        padding: "7px 8px",
        minWidth: "64px",
        fontSize: "0.8125rem",
        minHeight: "32px",
        margin: "0px 4px",
    }
};


const DappProfile = createReactClass({
    //class UserProfile extends React.Component {
    //function UserProfile({ ...props }) {
    mixins: [
        Reflux.connect(DappsStore, "data")
    ],
    /*
    state: { open: false },
    handleClick(){
      this.setState({ open: !this.state.open });
    },
    */

    getDappUrl(dapp) {
        return 'https://dappstore.link/dapp/' + dapp.slug;
    },
    getFacebookShareUrl(dapp) {
        return 'https://www.facebook.com/sharer/sharer.php?u=' + this.getDappUrl(dapp) + '&t=' + dapp.title;
    },
    getTwitterShareUrl(dapp) {
        return 'https://twitter.com/share?url=' + this.getDappUrl(dapp) + '&text=' + dapp.title;
    },
    // https://twitter.com/share?url=URLENCODED_URL&via=TWITTER_HANDLE&text=TEXT
    getBody(dapp) {
        let buttonStyle = {
            lineHeight: '2',
            fontSize: '14px',
            padding: '12px 62px',
            marginBottom: '10px',
        };
        return <div>
                {dapp.description}<br/><br/>
                <p>
              <Button style={style.shareButton}  color="facebook" onClick={ (e) => this.onShareFacebook(dapp)} round>
                <Share/>   Facebook
              </Button>
              <Button style={style.shareButton} color="info" onClick={ (e) => this.onShareTwitter(dapp)} round>
                <Share/>   Twitter
              </Button>
              </p>
              <br />
              <br />
              <Button color="success" href={ dapp.url } rel="noopener" onClick={ (e) => this.onStartClick(dapp)} target="_blank" style={buttonStyle}>
                Enter DApp  
                <PlayArrow/> 
              </Button>
        </div>
    },

    onShareFacebook(dapp) {
        let facebookShareUrl = this.getFacebookShareUrl(dapp);
        window.open(facebookShareUrl, 'share', 'width=600,height=400');
        this.onShare('facebook', 'click');
    },

    onShareTwitter(dapp) {
        let twitterShareUrl = this.getTwitterShareUrl(dapp);
        window.open(twitterShareUrl, 'share', 'width=600,height=400');
        this.onShare('twitter', 'click');
    },

    onStartClick(dapp) {
        ReactGA.event({
            category: 'Dapp',
            action: 'Start Dapp',
            label: 'Start ' + dapp.title
        });
    },

    onShare(type, action) {
        ReactGA.event({
            category: 'Share',
            action: 'Share ' + type,
            label: 'Start ' + type + ' action',
        });
    },

    getRelatedItems(dapp) {
        let dapps = DappsStore.getRelatedDapps(dapp);

        return dapps.map((value, index) => (
            <ItemGrid key={ index } xs={12} sm={6} md={6} lg={4}>
                <ChartCard
            chart={ <DappIcon size={150} dapp={ value } style={ {
                marginTop: '4px',
                marginLeft: '4px',
                background: 'white',
                borderRadius: '50%'
            }} /> }
            data={ value }
            text={ value.description }
            statText={ value.category }
            statLink={{
                text: value.category,
                href: '/' + value.category + 's'
            }}
            />
          </ItemGrid>
        ));
    },

    render() {

        var slug = this.props.location.pathname.replace('/dapp/', '');
        var dapp = DappsStore.getDappBySlug(slug);
        if (!dapp) return <div/>
        /*
          document.querySelector('meta[property="og:title"]').setAttribute("content", dapp.title);
          document.querySelector('meta[property="og:description"]').setAttribute("content", dapp.description);
          document.querySelector('meta[property="og:url"]').setAttribute("content", this.getDappUrl(dapp));
        */
        const meta = {
            title: dapp.title,
            description: dapp.description,
            canonical: this.getDappUrl(dapp),
            meta: {
                property: {
                    'og:title': dapp.title,
                    'og:description': dapp.description,
                    'og:url': this.getDappUrl(dapp)
                }
            }
        };

        return (

            <DocumentMeta {...meta}>
    <div>
      <Grid container>
        <ItemGrid xs={12} sm={12} md={12} lg={8}>
          <ProfileCard
            avatar={ <DappIcon dapp={dapp} size={130} style={ {
                background: 'white'
            }} /> }
            subtitle={ dapp.category }
            title={ dapp.title }
            description={ this.getBody(dapp)}
            />
        </ItemGrid>
        <ItemGrid xs={12} sm={12} md={12} lg={4}>

          <RegularCard
            cardTitle="Statistics"
            headerColor="blue"
            content={
            <div>
                <Grid container>
                    <ItemGrid xs={2} sm={1} md={2} style={ style.note }>
                      <Muted><EthAlt /></Muted>
                    </ItemGrid>
                    <ItemGrid xs={7} sm={8} md={7} style={ style.note }>
                      { 'Balance' }
                    </ItemGrid>
                    <ItemGrid xs={3} sm={3} md={3} style={ style.note }>
                      <b>{ dapp.balance }</b>
                    </ItemGrid>

                    <ItemGrid xs={2} sm={1} md={2} style={ style.note }>
                      <Muted><ImportExport /></Muted>
                    </ItemGrid>
                    <ItemGrid xs={7} sm={8} md={7} style={ style.note }>
                      { 'Transactions (24h)' }
                    </ItemGrid>
                    <ItemGrid xs={3} sm={3} md={3} style={ style.note }>
                      <b>{ dapp.tx }</b>
                    </ItemGrid>

                    <ItemGrid xs={2} sm={1} md={2} style={ style.note }>
                      <Muted><People /></Muted>
                    </ItemGrid>
                    <ItemGrid xs={7} sm={8} md={7} style={ style.note }>
                      { 'Daily Active Users' }
                    </ItemGrid>
                    <ItemGrid xs={3} sm={3} md={3} style={ style.note }>
                      <b>{ dapp.dau }</b>
                    </ItemGrid>
                </Grid>
              </div>
            }
            />
            <RegularCard
            cardTitle="User Rating"
            headerColor="orange"
            content={
            <div style={ style.centerText }>
                <div style={ style.rate }>{dapp.stars + ".0"}</div>
                <StarRatingComponent
            className="dapp-stars-profile"
            name={"rate1" + dapp.id}
            editing={ true }
            starCount={5}
            value={ dapp.stars }
            onStarClick={ e => console.log('click star')}
            />
              </div>
            }
            />
        </ItemGrid>
        <h4>Related Dapps</h4>
            <Grid container>
            { this.getRelatedItems(dapp)}
            </Grid>
      </Grid>
    </div> </DocumentMeta>
        );
    }
});

export default DappProfile;



// WEBPACK FOOTER //
// ./src/views/DappProfile/DappProfile.jsx